import React, { useState, useCallback } from 'react';
import { Autocomplete, Stack, Tag } from "@shopify/polaris";
import { FieldRenderProps } from 'react-final-form';
import styles from "../AddProductsUsingFiltersModal.module.css";

interface CheckboxOption {
    label: string;
    value: string;
}

interface CheckboxGroupProps extends FieldRenderProps<string[], HTMLElement> {
    options: CheckboxOption[];
    label?: string;
}

const CheckboxGroupFormField: React.FC<CheckboxGroupProps> = ({ input, options, label }) => {
    const [selectedOptions, setSelectedOptions] = useState<string[]>(Array.isArray(input.value) ? input.value : []);
    const [filteredOptions] = useState(options);

    const removeTag = useCallback(
        (tag: string) => () => {
            const newSelectedOptions = selectedOptions.filter((option) => option !== tag);
            setSelectedOptions(newSelectedOptions);
            input.onChange(newSelectedOptions);
        },
        [selectedOptions, input]
    );

    const handleSelect = (selected: string[]) => {
        const newSelectedOptions = [...selectedOptions, ...selected.filter((item) => !selectedOptions.includes(item))];
        setSelectedOptions(newSelectedOptions);
        input.onChange(newSelectedOptions);
    };

    const verticalContentMarkup =
        selectedOptions.length > 0 ? (
            <Stack spacing="extraTight" alignment="center">
                {selectedOptions.map((option) => {
                    const optionLabel = options.find((opt) => opt.value === option)?.label || option;
                    return (
                        <Tag key={`option${option}`} onRemove={removeTag(option)}>
                            {optionLabel}
                        </Tag>
                    );
                })}
            </Stack>
        ) : null;

    const textField = (
        <div className={styles.inputWrapper}>
            <Autocomplete.TextField
                onChange={() => { }}
                label={label}
                value=""
                placeholder="Select"
                verticalContent={verticalContentMarkup}
                autoComplete="off"
                readOnly
            />
        </div>
    );

    return (
        <div>
            <Autocomplete
                allowMultiple
                options={filteredOptions.map((option) => ({
                    value: option.value,
                    label: option.label
                }))}
                selected={selectedOptions}
                textField={textField}
                onSelect={handleSelect}
                listTitle="Suggested"
            />
        </div>
    );
};

export default CheckboxGroupFormField;